import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { ControlHostService } from '../commonServices/control-host.service';

export const controlHostResolver: ResolveFn<boolean> = (route, state) => {
  return inject(ControlHostService).get();
};
